











import {Component, Watch, Vue, Prop, Provide} from 'vue-property-decorator';
import PlanHeader from '@/views/journals/plan/PlanHeader.vue';
import PlanBody from '@/views/journals/plan/PlanBody.vue';
import PlanFooter from '@/views/journals/plan/PlanFooter.vue';
import {mapActions, mapGetters, mapState} from 'vuex';
import PlanDialog from '@/views/journals/plan/PlanDialog.vue';
import {DialogData} from '@/models/PlanModel';
import {fetchSaveCreate} from '@/api/journals/plan';
import CDeleteDialog from '@/components/base/dialog/CDeleteDialog.vue';

@Component({
    components: {
        CDeleteDialog,
        PlanHeader,
        PlanBody,
        PlanFooter,
        PlanDialog,
    },
    computed: {
        ...mapState('plan', ['loading', 'currentPageIndex', 'currentRowCount']),
        ...mapGetters('plan', ['items']),
    },
    methods: {
        ...mapActions('plan', ['getData', 'create', 'download', 'delete', 'deleteAll']),
    },
})
export default class Plan extends Vue {
    @Provide()
    @Prop({default: false, type: Boolean})
    inSearch!: boolean;

    public loading!: boolean;
    public getData!: Function;
    public create!: Function;
    public download!: Function;
    public delete!: Function;
    public deleteAll!: Function;
    public currentPageIndex!: number;
    public currentRowCount!: number;

    @Watch('currentPageIndex', {immediate: true})
    onCurrentPageIndexChange(value: number, oldValue: number | undefined) {
        if ((this.$route.query.page && oldValue === undefined) || +this.$route.query?.page === value) return;
        this.$router
            .replace({
                query: {
                    page: String(value),
                    size: String(this.currentRowCount),
                },
            })
            .catch(() => {});
    }

    @Watch('currentRowCount', {immediate: true})
    onCurrentRowCount(value: number, oldValue: number | undefined) {
        if ((this.$route.query.size && oldValue === undefined) || +this.$route.query?.size === value) return;
        this.$router
            .replace({
                query: {
                    page: String(this.currentPageIndex),
                    size: String(value),
                },
            })
            .catch(() => {});
    }

    created() {
        const pageIndex = +this.$route.query?.page || this.currentPageIndex;
        const rowCount = +this.$route.query?.size || this.currentRowCount;
        this.getData({
            pageIndex,
            rowCount,
        });
    }

    async onAdd() {
        try {
            const data: DialogData = await this.create();
            (this.$refs.planDialog as any).open(data, {
                title: this.$t('Common.Add'),
                saveCallback: async (payload: DialogData) => {
                    try {
                        const {data} = await fetchSaveCreate(payload);
                        this.$router.push({
                            name: 'planEdit',
                            params: {
                                idPlan: data.Id,
                                externalData: JSON.stringify(data),
                            },
                        });
                    } finally {
                        (this.$refs.planDialog as any).close();
                    }
                },
            });
        } catch {}
    }

    onDelete(id: number) {
        (this.$refs.deleteDialog as any).open(id, {
            deleteCallback: async (id: number) => {
                try {
                    const error = await this.delete({id, page: this.currentPageIndex, size: this.currentRowCount});
                    if (error) (this.$refs.deleteDialog as any).error(error);
                    else (this.$refs.deleteDialog as any).close();
                } catch (e) {
                    (this.$refs.deleteDialog as any).close();
                    console.error(e);
                }
            },
        });
    }

    onDeleteAll() {
        (this.$refs.deleteDialog as any).open(null, {
            deleteCallback: async () => {
                try {
                    const error = await this.deleteAll();
                    if (error) (this.$refs.deleteDialog as any).error(error);
                    else (this.$refs.deleteDialog as any).close();
                } catch (e) {
                    (this.$refs.deleteDialog as any).close();
                    console.error(e);
                }
            },
        });
    }

    async onDownload(id: number) {
        try {
            const response = await this.download(id);
            const cd = response.headers['content-disposition'],
                fileName = cd.match(/filename=[\w]+\.[\w]+/gi)[0].replace('filename=', ''),
                link = document.createElement('a');
            link.href = URL.createObjectURL(response.data);
            link.download = fileName;
            document.body.appendChild(link);
            setTimeout(function() {
                URL.revokeObjectURL(link.href);
            }, 4e4); // 40s
            setTimeout(function() {
                link.click();
            }, 0);
        } catch {}
    }

    onSelect(id: number) {
        this.$emit('search:input', id);
    }
}
